import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';


@Component({
  selector: 'app-ss-approval',
  templateUrl: './ss-approval.component.html',
  styleUrls: ['./ss-approval.component.scss']
})
export class SsApprovalComponent implements OnInit {

  listSigned: Array<any> = new Array<any>();
  listFilled: Array<any> = new Array<any>();

  excelFields = ['ID Ciclo', 'ID Empleado', 'Nombre Empleado', 'Fecha De Solicitud', 'Importe', 'Cuotas', 'Forma De Pago', 'Ahorrador', 'Tipo De Trabajo'];

  displayedColumns: string[] = ['select', 'employeeNumber', 'contributionAmount', 'numberOfPayments', 'status', 'contractUrl', 'accept', 'declined'];
  consultColumns: string[] = ['employeeNumber', 'contributionAmount', 'numberOfPayments', 'status', 'contractUrl', 'declined'];
  selection = new SelectionModel<any>(true, []);

  constructor(private dataSource: DataSourceService, public dialog: MatDialog, private ui: UiService) {

  }

  ngOnInit() {
    this.loadDate();
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.listSigned.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.listSigned.forEach(row => this.selection.select(row));
  }

  async loadDate() {
    let arraySigned: Array<any> = new Array<any>();
    let arrayFilled: Array<any> = new Array<any>();
    const shareSavingsResult = await this.dataSource.getShareSavings();
   // const shareSavingsParametersResult = await this.dataSource.getShareSavings();

    const shareSavingDoc = shareSavingsResult.docs.map(e => e.data());

    if (shareSavingDoc) {

      for (const element of shareSavingDoc) {
        if (element.user.employeeNumber && element.ssID) {
          const activeUser = await this.dataSource.loadShareSavingsUser(element.user.employeeNumber).pipe(take(1)).toPromise();
          if (activeUser.length > 0) {
            
          const contractData = await this.dataSource.loadSavingContract(element.ssID).pipe(take(1)).toPromise();

          if (contractData !== undefined) {

            if (contractData.status == 'signed') {
              let status = "firmado";
              const contractSignedURL = contractData.contractSignedURL ? contractData.contractSignedURL : '';
              arraySigned.push({
                employeeNumber: element.user.employeeNumber,
                ssID : element.ssID,
                contributionAmount: element.contributionAmount,
                numberOfPayments: element.numberOfPayments,
                status: status,
                dateRegister: contractData.date,
                contractUrl: contractSignedURL
              });

            }

            if (contractData.status == 'filled') {
              let status = "creado";
              arrayFilled.push({
                employeeNumber: element.user.employeeNumber,
                ssID : element.ssID,
                contributionAmount: element.contributionAmount,
                numberOfPayments: element.numberOfPayments,
                status: status,
                dateRegister: contractData.date,
                contractUrl: contractData.contractURL
              });
            }
          }
        }

        }
      }

      this.listSigned = arraySigned.sort((x, y) => x.dateRegister - y.dateRegister);
      this.listFilled = arrayFilled.sort((x, y) => x.dateRegister - y.dateRegister);

    }




  }

  downloadFile(url: string) {
    window.open(url, "_blank");
  }

  fullApproved() {
    const approvalRequests = this.selection.selected.length;
    const action = 'approved';
    console.log('aprobación masiva', this.selection.selected);

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Está seguro(a) que desea aprobar la solicitud de ${approvalRequests} colaborador(es)?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        const dataSave = { status: action };
        this.ui.showSpinner();
        let resultTrue = false;

        for (const iterator of this.selection.selected) {

          resultTrue = await this.dataSource.markStatusShareSaving(iterator.ssID, {status: 'active'}).then(() => {
            return this.dataSource.markSavingContract(iterator.ssID, dataSave).then(() => {
              return true;
            }).catch(() => {
              return false;
            });
          }).catch(error => {
            console.log('activeError', error.message);
            return false;
          });
        }

        if (resultTrue == true) {
          resultTrue
          this.ui.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Los cambios se han guardado exitosamente.',
              close: 'Aceptar'
            }
          });
          location.reload();
        } else {
          this.ui.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Ocurrio una intermitencia en el proceso favor de actualizar la página.',
              close: 'Aceptar'
            }
          });
          location.reload();
        }

      }
    });


  }

  process(ssID: string, action: string) {

    const textAction = action === 'approved' ? 'aprobar' : 'rechazar';
    let markAction : any ;

    if(action === 'approved'){
      markAction =  { status: 'active' };
    }else{
      markAction = {
        active: false,
        status: 'canceled'
      }
    }


    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Está seguro(a) que desea ${textAction} esta solicitud?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
        this.ui.showSpinner();

        await this.dataSource.markStatusShareSaving(ssID, markAction).catch(error => {
          console.log('activeError', error.message);
        });

        const dataSave = { status: action };
        this.dataSource.markSavingContract(ssID, dataSave).then(() => {
          this.ui.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Los cambios se han guardado exitosamente.',
              close: 'Aceptar'
            }
          });
          location.reload();
        }).catch(() => {
          this.ui.stopSpinner();
        });
      }
    });

  }

}
